module.exports = __webpack_public_path__ + "img/logo.a0185b04.svg";